import { callApi } from './api';

import { SupportPlanRequest } from '@/types/supportPlan';

export const updateSupportPlan = async (supportPlanID: number, requestBody: SupportPlanRequest) => {
  const { status, result } = await callApi<boolean>(
    `support-plans/${supportPlanID}`,
    'PUT',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
